import { apolloClient } from '@/graph/apollo'

const mutateWrapper = (mutation, variables, apolloArgs = {}) =>
  apolloClient.mutate({
    mutation,
    variables,
    ...apolloArgs
  })

export const addToCache = (query, field) => (cache, result) => {
  try {
    const data = cache.readQuery({ query })

    const item = result.data[Object.keys(result.data)[0]]

    data[field].push(item)
    cache.writeQuery({ query, data })
  } catch (ignore) {}
}

export const removeFromCache = (query, field) => (cache, result) => {
  try {
    const data = cache.readQuery({ query })

    const item = result.data[Object.keys(result.data)[0]]

    data[field] = data[field].filter(x => x.id !== item.id)
    cache.writeQuery({ query, data })
  } catch (ignore) {}
}

export default mutateWrapper
